import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import API from "../../services/api";

import PopupTextBlock from "../../components/popups/PopupTextBlock";

import PopupImageBlock from "../../components/popups/PopupImageBlock";
import PopupVideoBlock from "../../components/popups/PopupVideoBlock";
import PopupButtonBlock from "../../components/popups/PopupButtonBlock";

import PopupRenderer from "../../components/popups/PopupRenderer";

import "./AdminPopupEditor.css";

function AdminPopupEditor() {

  const { id } =
  useParams();

  const [popups, setPopups] =
    useState([]);

const [popup, setPopup] = useState({
  title: "",
  status: "draft",
  audience: "all",
  startDate: "",
  endDate: "",
  maxViews: 1,
  intervalMinutes: 15,
  autoCloseMinutes: 0,
  priority: 1,
  size: "medium",
  position: "center",
  animation: "fade",
  pages: ["all"],
  blocks: []
});

  const loadPopups =
    async () => {

      try {

        const res =
          await API.get(
            "/popups"
          );

        setPopups(res.data);

      }

      catch(error) {

        console.log(error);

      }

    };

    useEffect(() => {

  if(!id) return;

  const loadPopup =
    async () => {

      try {

        const res =
          await API.get(
            `/popups/${id}`
          );

        setPopup(
          res.data
        );

      }

      catch(error) {

        console.log(error);

      }

    };

  loadPopup();

}, [id]);

  useEffect(() => {

    loadPopups();

  }, []);

  const addTextBlock = () => {

    setPopup(prev => ({

      ...prev,

      blocks: [

        ...prev.blocks,

        {

          id: Date.now(),

          type: "text",

          content: "",

          color: "#ffffff",

          fontSize: 18,

          textAlign: "left"

        }

      ]

    }));

  };

  const addImageBlock = () => {

  setPopup(prev => ({

    ...prev,

    blocks: [

      ...prev.blocks,

      {
        id: Date.now(),
        type: "image",
        url: "",
        width: 100
      }

    ]

  }));

};

const addVideoBlock = () => {

  setPopup(prev => ({

    ...prev,

    blocks: [

      ...prev.blocks,

      {
        id: Date.now(),
        type: "video",
        url: ""
      }

    ]

  }));

};

const addButtonBlock = () => {

  setPopup(prev => ({

    ...prev,

    blocks: [

      ...prev.blocks,

      {
        id: Date.now(),
        type: "button",
        label: "Cliquez ici",
        url: "",
        background: "#ff7b00",
        color: "#ffffff"
      }

    ]

  }));

};

const saveDraft = () => {

  savePopup("draft");

};

const publishPopup = () => {

  savePopup("published");

};

const deletePopup = async () => {

  if (!popup._id) return;

  if (
    !window.confirm(
      "Supprimer ce popup ?"
    )
  ) return;

  try {

    await API.delete(
      `/popups/${popup._id}`
    );

    alert("Popup supprimé");

    loadPopups();

setPopup({
  title: "",
  status: "draft",
  audience: "all",
  startDate: "",
  endDate: "",
  maxViews: 1,
  intervalMinutes: 15,
  priority: 1,
  size: "medium",
  position: "center",
  animation: "fade",
  pages: ["all"],
  blocks: []
});

  }

  catch(error) {

    console.log(error);

  }

};

  const updateBlock =
    (id, field, value) => {

      setPopup(prev => ({

        ...prev,

        blocks:

          prev.blocks.map(

            block =>

              block.id === id

              ? {
                  ...block,
                  [field]: value
                }

              : block

          )

      }));

    };

  const removeBlock =
    (id) => {

      setPopup(prev => ({

        ...prev,

        blocks:

          prev.blocks.filter(

            block =>
              block.id !== id

          )

      }));

    };

  const editPopup =
    (selectedPopup) => {

      setPopup(
        selectedPopup
      );

    };

  const savePopup =
    async (status) => {

      try {

        const data = {

          ...popup,

          status

        };

        if (popup._id) {

          await API.put(

            `/popups/${popup._id}`,

            data

          );

        }

        else {

          await API.post(

            "/popups",

            data

          );

        }

        loadPopups();

        alert(
          "Popup enregistré"
        );

      }

      catch(error) {

        console.log(error);

      }

    };

  return (

    <div className="admin-popup-editor">

      <div className="popup-sidebar">

        <h2>
          Popups
        </h2>

        {

          popups.map(item => (

            <button

              key={item._id}

              className="popup-item"

              onClick={() =>
                editPopup(item)
              }

            >

              {item.title}

            </button>

          ))

        }

      </div>

      <div className="popup-editor">

        <h1>
          Editeur Popup
        </h1>

        <input

          type="text"

          placeholder="Titre"

          value={popup.title}

          onChange={(e)=>

            setPopup({

              ...popup,

              title:
                e.target.value

            })

          }

        />

   <div className="popup-toolbar">

  <button onClick={addTextBlock}>
    ➕ Texte
  </button>

  <button onClick={addImageBlock}>
    🖼️ Image
  </button>

  <button onClick={addVideoBlock}>
    🎬 Vidéo
  </button>

  <button onClick={addButtonBlock}>
    🔘 Bouton
  </button>

</div>

        {popup.blocks.map(block => {

  switch(block.type) {

    case "text":

      return (

        <PopupTextBlock

          key={block.id}

          block={block}

          updateBlock={updateBlock}

          removeBlock={removeBlock}

        />

      );

    case "image":

      return (

        <PopupImageBlock

          key={block.id}

          block={block}

          updateBlock={updateBlock}

          removeBlock={removeBlock}

        />

      );

    case "video":

      return (

        <PopupVideoBlock

          key={block.id}

          block={block}

          updateBlock={updateBlock}

          removeBlock={removeBlock}

        />

      );

    case "button":

      return (

        <PopupButtonBlock

          key={block.id}

          block={block}

          updateBlock={updateBlock}

          removeBlock={removeBlock}

        />

      );

    default:

      return null;

  }

})}

        
        <div className="form-group">

  <label>
    Taille du popup
  </label>

  <select
    value={popup.size}
    onChange={(e)=>
      setPopup({
        ...popup,
        size: e.target.value
      })
    }
  >

    <option value="small">
      Petit
    </option>

    <option value="medium">
      Moyen
    </option>

    <option value="large">
      Grand
    </option>

    <option value="fullscreen">
      Plein écran
    </option>

  </select>

</div>

<div className="form-group">

  <label>
    Position
  </label>

  <select
    value={popup.position}
    onChange={(e)=>
      setPopup({
        ...popup,
        position: e.target.value
      })
    }
  >

    <option value="center">
      Centre
    </option>

    <option value="top">
      Haut
    </option>

    <option value="bottom">
      Bas
    </option>

    <option value="left">
      Gauche
    </option>

    <option value="right">
      Droite
    </option>

  </select>

</div>

<div className="form-group">

  <label>
    Priorité
  </label>

  <input
    type="number"
    min="1"
    max="100"
    value={popup.priority}
    onChange={(e)=>
      setPopup({
        ...popup,
        priority: Number(
          e.target.value
        )
      })
    }
  />

</div>

<div className="form-group">

  <label>
    Animation
  </label>

  <select
    value={popup.animation}
    onChange={(e)=>
      setPopup({
        ...popup,
        animation: e.target.value
      })
    }
  >

    <option value="fade">
      Fade
    </option>

    <option value="slide">
      Slide
    </option>

    <option value="zoom">
      Zoom
    </option>

    <option value="bounce">
      Bounce
    </option>

  </select>

</div>

<div className="form-group">

  <label>
    Pages concernées
  </label>

  <select
    multiple
    value={popup.pages}
    onChange={(e)=>
      setPopup({
        ...popup,
        pages: Array.from(
          e.target.selectedOptions,
          option => option.value
        )
      })
    }
  >

    <option value="all">
      Toutes les pages
    </option>

    <option value="/">
      Accueil
    </option>

    <option value="/matches">
      Matchs
    </option>

    <option value="/vip">
      VIP
    </option>

    <option value="/profile">
      Profil
    </option>

  </select>

</div>


<div className="popup-settings">

  <h3>
    Paramètres
  </h3>

  <label>
    Audience
  </label>

  <select

    value={popup.audience}

    onChange={(e)=>

      setPopup({

        ...popup,

        audience: e.target.value

      })

    }

  >

    <option value="all">
      Tous
    </option>

    <option value="guest">
      Invités
    </option>

    <option value="logged">
      Connectés
    </option>

    <option value="vip">
      VIP
    </option>

    <option value="non_vip">
      Connectés non VIP
    </option>

    <option value="admin">
      Admin
    </option>

  </select>

  <label>
    Début
  </label>

  <input

    type="datetime-local"

    value={popup.startDate || ""}

    onChange={(e)=>

      setPopup({

        ...popup,

        startDate: e.target.value

      })

    }

  />

  <label>
    Fin
  </label>

  <input

    type="datetime-local"

    value={popup.endDate || ""}

    onChange={(e)=>

      setPopup({

        ...popup,

        endDate: e.target.value

      })

    }

  />

  <label>

    Nombre de vues

  </label>

  <input

    type="number"

    min="1"

    value={popup.maxViews || 1}

    onChange={(e)=>

      setPopup({

        ...popup,

        maxViews: Number(
          e.target.value
        )

      })

    }

  />

  <label>

    Intervalle (minutes)

  </label>

  <input

    type="number"

    min="1"

    value={popup.intervalMinutes || 15}

    onChange={(e)=>

      setPopup({

        ...popup,

        intervalMinutes: Number(
          e.target.value
        )

      })

    }

  />

  <div className="form-group">

  <label>
    Fermeture automatique (minutes)
  </label>

  <input
    type="number"
    min="0"
    value={popup.autoCloseMinutes || 0}
    onChange={(e) =>
      setPopup({
        ...popup,
        autoCloseMinutes: Number(
          e.target.value
        )
      })
    }
  />

  <small>
    0 = fermeture manuelle uniquement
  </small>

</div>

</div>

<div className="popup-actions">

  <button className="brouillon-action"
    onClick={saveDraft}
           style={{
  
      background: "var(--encours-back)",
      color: "var(--encours)",
     
    }}
  >
    💾 Brouillon
  </button>

  <button className="publier-action"
    onClick={publishPopup}
           style={{
  
      background: "var(--reussi-back)",
      color: "var(--reussi)",
     
    }}
  >
    🚀 Publier
  </button>

  <button 
    onClick={deletePopup}

        style={{
  
      background: "var(--echec-back)",
      color: "var(--echec)",
     
    }}
  >

    🗑️ Supprimer
  </button>

</div>


      </div>

    <div className="popup-preview">

  <h2>
    Prévisualisation
  </h2>


  <PopupRenderer
    popup={popup}
  />

  

</div>

    </div>

  );

}

export default AdminPopupEditor;